import React from "react";
import { useSessionStorage } from "react-use";
import { googleLogout } from '@react-oauth/google';

const defaultValues = Object.freeze({
  isAuthenticated: false,
  principal: null,
  login: () => {},
  logout: () => {},
});

const STOREGE_KEY = "authentication";

export const AuthenticationContext = React.createContext(defaultValues);

export function AuthenticationProvider({ children }) {
  const [authentication, setAuthentication] = useSessionStorage(
    STOREGE_KEY,
    defaultValues
  );

  const login = (principal) =>{
  //console.log(principal);
    setAuthentication({ isAuthenticated: true, principal });
  }

  const logout = () => {
    setAuthentication(defaultValues);
    googleLogout();
  }

  const authenticationValue = { ...authentication, login, logout };

  return (
    <AuthenticationContext.Provider value={authenticationValue}>
      {children}
    </AuthenticationContext.Provider>
  );
}

export function useAuthentication() {
  return React.useContext(AuthenticationContext);
}
